import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './Footer';
import './Layout.css';

const Layout = ({ children }) => {
  const location = useLocation();
  const isContactPage = location.pathname === '/contact';

  // Ensure scroll to top on route change (backup to ScrollToTop component)
  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [location.pathname]);
  
  return (
    <div className="layout">
      <Header />
      <main className={`main-content ${isContactPage ? 'contact-page-wrapper' : ''}`}>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout; 